"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inject = void 0;

var _styledComponents = require("styled-components");

var _theme = require("../../../theme");

var _utils = require("../../../utils");

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      grid-", ": unset;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["grid-", ": ", " / span ", ""]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n                ", "\n              "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n\n          ", ";\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n\n          grid-gap: ", "rem;\n\n          ", ";\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        ", ";\n\n        ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          max-width: calc(\n            ", " - ", "px\n          );\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        ", ";\n\n        ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultGridDirection = 'row',
    defaultGridTemplate = '',
    defaultGridGap = 0;

var _definedBreakpoints = function _definedBreakpoints(_ref) {
  var breakpoints = _ref.breakpoints,
      divisions = _ref.divisions,
      _ref$cellsCount = _ref.cellsCount,
      cellsCount = _ref$cellsCount === void 0 ? 0 : _ref$cellsCount;
  return Object.keys(breakpoints).filter(function (breakpoint) {
    return breakpoints[breakpoint] || ((divisions === null || divisions === void 0 ? void 0 : divisions[breakpoint]) || 0) !== cellsCount;
  });
};

var _getElementTemplate = function _getElementTemplate(breakpoints, _ref2) {
  var breakpointTemplateCallback = _ref2.breakpointTemplateCallback,
      defaultTemplate = _ref2.defaultTemplate;

  if (breakpoints.length) {
    return breakpoints.reduce(function (destinationTemplate, breakpoint) {
      return breakpointTemplateCallback({
        destinationTemplate: destinationTemplate,
        breakpoint: breakpoint
      });
    }, "");
  }

  return defaultTemplate;
};

var _getBreakpointData = function _getBreakpointData(_ref3) {
  var breakpoints = _ref3.breakpoints,
      breakpoint = _ref3.breakpoint;
  return (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints[breakpoint]) ? _objectSpread({}, breakpoints[breakpoint]) : {};
};

var _gridTemplate = function _gridTemplate(_ref4) {
  var _ref4$direction = _ref4.direction,
      direction = _ref4$direction === void 0 ? defaultGridDirection : _ref4$direction,
      _ref4$template = _ref4.template,
      template = _ref4$template === void 0 ? defaultGridTemplate : _ref4$template,
      divisions = _ref4.divisions;
  return (0, _styledComponents.css)(_templateObject(), "grid-template-".concat((0, _utils.reverseDirection)(direction), "s: ").concat(template || "repeat(".concat(divisions, ", 1fr)")), "grid-template-".concat(direction, "s: unset;"));
};

var gridContainerStyles = function gridContainerStyles(_ref5) {
  var breakpoints = _ref5.breakpoints;
  return _getElementTemplate(Object.keys(breakpoints), {
    breakpointTemplateCallback: function breakpointTemplateCallback(_ref6) {
      var destinationTemplate = _ref6.destinationTemplate,
          breakpoint = _ref6.breakpoint;

      var _getBreakpointData2 = _getBreakpointData({
        breakpoints: breakpoints,
        breakpoint: breakpoint
      }),
          maxWidth = _getBreakpointData2.maxWidth,
          _getBreakpointData2$g = _getBreakpointData2.gap,
          gap = _getBreakpointData2$g === void 0 ? defaultGridGap : _getBreakpointData2$g,
          _getBreakpointData2$d = _getBreakpointData2.direction,
          direction = _getBreakpointData2$d === void 0 ? defaultGridDirection : _getBreakpointData2$d;

      return (0, _styledComponents.css)(_templateObject2(), destinationTemplate, _theme.Mixin.Screen[breakpoint]((0, _styledComponents.css)(_templateObject3(), maxWidth ? "".concat(maxWidth, "px") : "var(--bp-".concat(breakpoint, ")"), 2 * (gap && direction === 'row' ? gap : 0))));
    },
    defaultTemplate: ''
  });
};

var gridBreakpointTemplate = function gridBreakpointTemplate(_ref7) {
  var divisions = _ref7.divisions,
      cellsCount = _ref7.cellsCount,
      breakpoints = _ref7.breakpoints;
  return _getElementTemplate(_definedBreakpoints({
    breakpoints: breakpoints,
    divisions: divisions,
    cellsCount: cellsCount
  }), {
    breakpointTemplateCallback: function breakpointTemplateCallback(_ref8) {
      var destinationTemplate = _ref8.destinationTemplate,
          breakpoint = _ref8.breakpoint;

      var _ref9 = breakpoints[breakpoint] || {},
          _ref9$direction = _ref9.direction,
          direction = _ref9$direction === void 0 ? defaultGridDirection : _ref9$direction,
          _ref9$template = _ref9.template,
          template = _ref9$template === void 0 ? defaultGridTemplate : _ref9$template,
          _ref9$gap = _ref9.gap,
          gap = _ref9$gap === void 0 ? defaultGridGap : _ref9$gap,
          alignment = _ref9.alignment;

      return (0, _styledComponents.css)(_templateObject4(), destinationTemplate, _theme.Mixin.Screen[breakpoint]((0, _styledComponents.css)(_templateObject5(), _gridTemplate({
        direction: direction,
        template: template,
        divisions: divisions[breakpoint]
      }), gap / 16, (0, _utils.getAlignment)({
        direction: direction,
        alignment: alignment
      }))));
    },
    defaultTemplate: (0, _styledComponents.css)(_templateObject6(), _gridTemplate({
      divisions: cellsCount
    }))
  });
};

var cellTemplate = function cellTemplate(_ref10) {
  var cellsSizes = _ref10.cellsSizes,
      index = _ref10.index,
      gridBreakpoints = _ref10.gridBreakpoints,
      breakpoints = _ref10.breakpoints,
      offsets = _ref10.offsets;
  return _getElementTemplate(Object.keys(breakpoints).filter(function (breakpoint) {
    var _offsets$breakpoint;

    return breakpoints[breakpoint] || (((_offsets$breakpoint = offsets[breakpoint]) === null || _offsets$breakpoint === void 0 ? void 0 : _offsets$breakpoint[index - 1]) || 0) !== 0;
  }), {
    breakpointTemplateCallback: function breakpointTemplateCallback(_ref11) {
      var destinationTemplate = _ref11.destinationTemplate,
          breakpoint = _ref11.breakpoint;

      var _getBreakpointData3 = _getBreakpointData({
        breakpoints: gridBreakpoints,
        breakpoint: breakpoint
      }),
          _getBreakpointData3$d = _getBreakpointData3.direction,
          gridDirection = _getBreakpointData3$d === void 0 ? defaultGridDirection : _getBreakpointData3$d,
          _getBreakpointData3$t = _getBreakpointData3.template,
          gridTemplate = _getBreakpointData3$t === void 0 ? defaultGridTemplate : _getBreakpointData3$t;

      var _getBreakpointData4 = _getBreakpointData({
        breakpoints: breakpoints,
        breakpoint: breakpoint
      }),
          _getBreakpointData4$s = _getBreakpointData4.size,
          size = _getBreakpointData4$s === void 0 ? 1 : _getBreakpointData4$s,
          offset = _getBreakpointData4.offset;

      var _ref12 = offset || {},
          _ref12$before = _ref12.before,
          offsetBefore = _ref12$before === void 0 ? 0 : _ref12$before;

      var start = cellsSizes[breakpoint].slice(0, index).reduce(function (allSizes, currentSize) {
        return allSizes + currentSize;
      }, 1);
      return (0, _styledComponents.css)(_templateObject7(), destinationTemplate, !gridTemplate ? (0, _styledComponents.css)(_templateObject8(), _theme.Mixin.Screen[breakpoint]((0, _styledComponents.css)(_templateObject9(), (0, _utils.reverseDirection)(gridDirection), start + offsetBefore + ((offsets === null || offsets === void 0 ? void 0 : offsets[index - 1]) || 0), size))) : "");
    },
    defaultTemplate: (0, _styledComponents.css)(_templateObject10(), defaultGridDirection)
  });
};

var inject = {
  gridBreakpointTemplate: gridBreakpointTemplate,
  gridContainerStyles: gridContainerStyles,
  cellTemplate: cellTemplate
};
exports.inject = inject;